import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";
import * as z from "zod/v4";

export const getAgentByNameAndVersion = {
  name: "getAgentByNameAndVersion" as const,
  input: VersionedAgentSchema.pick({ name: true }).extend({
    version: z.number(),
  }),
  output: VersionedAgentSchema,
};
